import { render, staticRenderFns } from "./dependencias.view.vue?vue&type=template&id=5f6dd22b&"
import script from "./dependencias.view.vue?vue&type=script&lang=js&"
export * from "./dependencias.view.vue?vue&type=script&lang=js&"
import style0 from "./dependencias.view.vue?vue&type=style&index=0&id=5f6dd22b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports